import type { UserModel } from "../models/user.model"

function userModelFallback(overrides?: Partial<UserModel>): UserModel {
  return {
    access: {
      class: "none",
    },
    accessAgreements: [],
    hasActiveSubscription: false,
    hasValidUserName: false,
    isLoggedIn: false,
    subscriptions: [],
    user: null,

    ...overrides,
  }
}

export const userWithAccessFallback = userModelFallback({
  hasActiveSubscription: true,
  isLoggedIn: false,
})

export const userWithoutAccessFallback = userModelFallback({
  hasActiveSubscription: false,
  isLoggedIn: false,
})
